import React from 'react';
import { motion } from 'framer-motion';
import { MdOutlineArchitecture, MdOutlineGroups, MdOutlineSentimentSatisfiedAlt, MdOutlineWorkspacePremium } from 'react-icons/md';
import './Stats.css';

const STATS_DATA = [
  { id: 1, icon: <MdOutlineArchitecture />, value: '2.5k', label: 'Projects Completed' },
  { id: 2, icon: <MdOutlineGroups />, value: '84+', label: 'Workers in Company' },
  { id: 3, icon: <MdOutlineSentimentSatisfiedAlt />, value: '12+', label: 'Benefit Every Day' },
  { id: 4, icon: <MdOutlineWorkspacePremium />, value: '05+', label: 'Received Awards' },
];

function Stats() {
  return (
    <section className="stats" id="History">
      <div className="container">
        <div className="stats__inner">

          {/* ── Left Content ───────────────────────────────── */}
          <motion.div 
            className="stats__content"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="section-label">Our Success in Numbers</div>
            <h2 className="stats__title">
              Excellence in Every Project <br /> Success in Every Roof
            </h2>
            <p className="stats__desc">
              Our success is a direct result of unwavering commitment to quality, 
              customer satisfaction, & excellence in every project we undertake. 
              With years of experience and a dedicated team of roofing experts.
            </p>

            <div className="stats__actions">
              <a href="#Contact" className="btn btn-primary" aria-label="Get an estimated quote">
                <span>Get an Estimated Quote</span>
              </a>
            </div>
          </motion.div>

          {/* ── Right Column (2x2 Stats Grid) ────────────────── */}
          <div className="stats__grid">
            {STATS_DATA.map((stat, idx) => (
              <motion.div 
                key={stat.id}
                className="stats__card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.15 }}
              >
                <div className="stats__icon-wrap">
                  {stat.icon}
                </div>
                <h3 className="stats__value">{stat.value}</h3>
                <span className="stats__label">{stat.label}</span>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}

export default Stats;
